var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "criteria-container" }, [
    !_vm.saved
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            staticClass: "criteria-container__text-area",
                            attrs: {
                              id: "comment",
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg":
                                "Favor escribir una descripción de criterios y procedimientos",
                              error: errors[0],
                              label:
                                "Describa los criterios y procedimientos que se utilizarán para evaluar el progreso del estudiante: ",
                              maxlength: 3000,
                              name: "comment",
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.criteria,
                              callback: function($$v) {
                                _vm.criteria = $$v
                              },
                              expression: "criteria"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1331319227
                )
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 mt-3 mt-md-2 d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-times-circle",
                  text: "Cancelar",
                  variant: "outline-danger mr-3"
                },
                on: { click: _vm.cancel }
              }),
              _c("action-button", {
                attrs: { i: "fa fa-save", text: "Guardar", variant: "success" },
                on: { click: _vm.saveCriteria }
              })
            ],
            1
          )
        ])
      : _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col-12 col-md-10" }, [
            _c("label", { staticClass: "input-display d-block" }, [
              _vm._v(
                " Describa los criterios y procedimientos que se utilizarán para evaluar el progreso del estudiante: "
              )
            ]),
            _c("span", { staticClass: "text-format" }, [
              _vm._v(_vm._s(_vm.data))
            ])
          ]),
          !_vm.readOnly
            ? _c(
                "div",
                { staticClass: "col-12 col-md-2 text-right" },
                [
                  _c("drop-down", {
                    staticClass: "criterias-action",
                    attrs: { items: _vm.actionItems }
                  })
                ],
                1
              )
            : _vm._e()
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }